import { MarketSegment } from '@/types/MarketSegment'

export const bySegmentName = (a: MarketSegment, b: MarketSegment) => {
  if (a.name < b.name) return -1
  else if (a.name > b.name) return 1
  else return 0
}
